import type { StorageAdapter } from "../adapter/adapter.js";

/** Tiny key/value bag used for theme, API keys, sync toggle, etc. */
export class SettingsRepository {
  constructor(private readonly db: StorageAdapter) {}

  async get(key: string): Promise<string | null> {
    const rows = await this.db.select<{ value: string }>(
      `SELECT value FROM settings WHERE key=?`, [key],
    );
    return rows[0]?.value ?? null;
  }

  async listAll(): Promise<Record<string, string>> {
    const rows = await this.db.select<{ key: string; value: string }>(
      `SELECT * FROM settings`,
    );
    return Object.fromEntries(rows.map((row) => [row.key, row.value]));
  }

  async set(key: string, value: string): Promise<void> {
    // SQLite UPSERT — every concrete adapter supports it.
    await this.db.execute(
      `INSERT INTO settings (key, value) VALUES (?, ?)
       ON CONFLICT(key) DO UPDATE SET value=excluded.value`,
      [key, value],
    );
  }

  async delete(key: string): Promise<void> {
    await this.db.execute(`DELETE FROM settings WHERE key=?`, [key]);
  }
}
